























































































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
// import { ScanRulesVuex, StoreVuex } from "@root/utiles/constant";
import { handlePaginationDecorator } from "@root/lib/decorator";
import { clearEmptyAttr, showConfirmDialog } from "@root/utiles/common";
import CustomSelect from "@/components/custom/CustomSelect.vue";
import TireDetailDialog from "./tireDetailDialog.vue";

import RemoteSelect from "@/components/custom/RemoteSelect.vue";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";
import { downloadFile } from "@/lib/common";

const root = namespace("root");
const common = namespace("common");
const rewardAccounting = namespace("rewardAccounting");
@Component({
  components: {
    CustomSelect,
    TireDetailDialog,
    RemoteSelect
  }
})
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@IsMore(true)
export default class RewardAccounting extends Vue {
  @root.State ddCodes;
  @common.Action queryDataDictionaryListLang;
  @rewardAccounting.Action bonusPaging: Function;
  // @rewardAccounting.Action storeSimplePaging;
  @rewardAccounting.Action rewardTradeBill;
  @rewardAccounting.Action bonusExport;
  @common.Action getDict;
  @common.Action storeSimpleSubPaging;

  private dataList = [];
  gtExportDialog = false;
  exportParams = {};
  dialogVisible: any = false;
  changeTypeList: any[] = [
    // { value: "1", label: "授权调整" },
    // { value: "2", label: "下单使用" },
    // { value: "3", label: "客户回款" }
  ];
  // 搜索参数
  private form: any = {
    orgCode: "",
    fundType: "",
    businessCodeLike: "",
    updateTime: null
  };
  tireDetailVisible: any = false; //涉及胎号弹出层
  tireDataList: any = [];
  searchParams: any = {};

  async created() {
    this.getData();
    this.getDicList();
  }
  async mounted() {}

  @loadingCatch
  async getData() {
    const { pageSize, currentPage: pageNum } = this as any;
    let { updateTime = [], ...others } = this.form;
    let input: any = {
      pageSize,
      pageNum,
      ...others
    };
    if (updateTime) {
      if (updateTime[0]) {
        input.updateTimeFrom = updateTime[0];
      }
      if (updateTime[1]) {
        input.updateTimeTo = updateTime[1];
      }
    }
    this.searchParams = input;
    try {
      let res = await this.bonusPaging(input);
      this.dataList = res.list || [];
      (this as any).total = res.total || 0;
    } catch (e) {
      console.log(e);
    }
  }
  async viewTireDetails(row) {
    console.log(row);
    let res = await this.rewardTradeBill({
      billCode: row.billCode
    });
    console.log(res, "--rewardTradeBill");
    this.tireDetailVisible = true;
    let result: any = [];
    if (res && res.list) {
      res.list.forEach(_ => {
        result.push(_.businessItemCode);
      });
      this.tireDataList = result;
    }
  }

  handleStoreSelect(data) {
    this.form.orgCode = data ? data.storeCode : "";
    console.log(data, "-handleStoreSelect-");
  }

  // 导出
  async exportFn() {
    let { pageSize, pageNum, ...others } = this.searchParams;

    let formData = new FormData();
    formData.append("AUTH-TOKEN", localStorage.getItem("AUTH-TOKEN-K-ONE-CN"));

    for (let i in others) {
      formData.append(i, others[i]);
    }
    let res: any = await this.bonusExport(formData);
    downloadFile(res.data, res.name || "");
  }

  async getDicList() {
    let res = await this.getDict({
      dictCodes: ["K2_REWARD_TRADE_FUND_TYPE"]
    });
    let dicMap: any = {};
    res.forEach(_ => {
      dicMap[_.code] = _.value || [];
    });
    this.changeTypeList = dicMap["K2_REWARD_TRADE_FUND_TYPE"];
    console.log(res, "--K2_REWARD_TRADE_FUND_TYPE");
  }
}
